import axios from "axios";
import { API_BASE } from "@/lib/api";

let scriptPromise = null;

export function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => {
      scriptPromise = null;
      reject(new Error("Failed to load Razorpay"));
    };
    document.body.appendChild(s);
  });
  return scriptPromise;
}

export async function payWithRazorpay({ orderPayload, prefill = {}, onPaid, onError, onDismiss }) {
  await loadRazorpayScript();
  const r = await axios.post(`${API_BASE}/razorpay/create-order`, orderPayload, { withCredentials: true });
  const { order_id, amount, currency, key_id, reference_id, description } = r.data;

  const rzp = new window.Razorpay({
    key: key_id,
    amount,
    currency,
    order_id,
    name: "Coach Sanjay",
    description,
    prefill,
    theme: { color: "#2D372B" },
    handler: async (resp) => {
      try {
        await axios.post(`${API_BASE}/razorpay/verify`, {
          razorpay_order_id: resp.razorpay_order_id,
          razorpay_payment_id: resp.razorpay_payment_id,
          razorpay_signature: resp.razorpay_signature,
          reference_id,
          order_type: orderPayload.order_type,
        });
        onPaid?.({ reference_id, amount });
      } catch (e) {
        onError?.(e?.response?.data?.detail || "Payment verification failed");
      }
    },
    modal: { ondismiss: () => onDismiss?.() },
  });
  rzp.on("payment.failed", (resp) => {
    onError?.(resp?.error?.description || "Payment failed. Please try again.");
  });
  rzp.open();
}
